const envApiUrl = process.env.REACT_APP_BASE_API_URL ? process.env.REACT_APP_BASE_API_URL.trim() : "";

const getDevelopmentApiUrl = () => {
    if (typeof window === "undefined") {
        return "http://localhost:9000/api/v1";
    }

    const protocol = window.location.protocol || "http:";
    const hostname = window.location.hostname || "localhost";
    return `${protocol}//${hostname}:9000/api/v1`;
};

const resolveApiUrl = () => {
    if (envApiUrl) {
        return envApiUrl;
    }

    if (process.env.NODE_ENV === "development") {
        return getDevelopmentApiUrl();
    }

    return "/api/v1";
};

const rawApiUrl = resolveApiUrl();
const normalizedEnvApiUrl = rawApiUrl.endsWith("/") ? rawApiUrl.slice(0, -1) : rawApiUrl;

export const BASE_API_URL = normalizedEnvApiUrl;

export function GetUserDisplayName(username, full_name) {
    let display_name = "";
    if (full_name) {
        display_name = full_name;
    } else {
        display_name = username;
    }

    return display_name;
}

export function GetUserInitials(display_name) {
    let initials = display_name.replace(/[^a-zA-Z- ]/g, "").match(/\b\w/g);
    initials = initials.join('');
    initials = initials.toUpperCase();

    return initials;
}

export function epochToJsDate(ts) {
    let dt = new Date(ts)
    return dt.toLocaleDateString() + " " + dt.toLocaleTimeString();
}
